import { controls, currencyToNumber, grouped } from "../../controls";

const rpad35 = {
  label: "Non Compliance Status",
  starting: true,
  url: "rp101m",
  pageLabel: "Non Compliance Status",
  pageType: "history",
  filter: [
  ],
  form: [],
  history: {
    perPage: 50,
    reportHeader: "Non Compliance Status",
    filterable: true,
    sortable: true,
    defaultsTo: 0,
    pdfProps: {
      pageSize: "A4", pageOrientation: "portrait",
      header: [
        [{ source: 'fixed', value: 'Bank:' }],
        [{ source: 'history', field: 'reportHeader', type: "capital" }]
      ]
    },
    displayColumns: [
      {
        Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30,
        width132: { size: 3 }
      },
      // {
      //   Header: "Bank",
      //   accessor: "client_display",
      //   rwidth: "*"
      // },
      // {
      //   Header: "Branch",
      //   accessor: "branch_display",
      // },
      // {
      //   Header: "Type",
      //   accessor: "insgroup",
      // },
      // {
      //   Header: "Inspecting Officer",
      //   accessor: "auditor_display",
      // },
      {
        Header: "Branch",
        accessor: "branch_display",
        rwidth: "*"
      },
      {
        Header: "Cash",
        accessor: "cash",

      },
      {
        Header: "Recon",
        accessor: "recon",

      },
      {
        Header: "Cheques & Bills",
        accessor: "cheques",

      },
      {
        Header: "Manual",
        accessor: "manual",

      },
      {
        Header: "General",
        accessor: "general",

      },
      {
        Header: "Loan",
        accessor: "loans",

      },
      {
        Header: "Deposit",
        accessor: "deposits",

      }
    ]
  }
};

export default rpad35;